import * as React from "react";
import ReadService from "../../../service/read";
import QNShortAnswers from "./vlus_answer_pane";


export default class VillageQuestionnairesPane extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            lus_elements:[],
            zones:[],
            regions:[],
            districts:[],
            villages:[],
            hamlets:[],
            wards:[],
            village:0,
            quest_name:'Click on Left Questionnaire',
            dodoso:[],
            tabs:["Answers","Tables","Graphs","Analysis"],
            current_tab:0,
            current_tab_pane:''
        }

        this.loadData = this.loadData.bind(this)
        this.handleChanges = this.handleChanges.bind(this)
        this.showQuestionnaireAt = this.showQuestionnaireAt.bind(this)
        this.showTabAt = this.showTabAt.bind(this)

    }

    handleChanges=(e)=>{
        this.setState({[e.target.name]:e.target.value})
    }



    componentDidMount() {
        this.loadData()
    }

    render() {
        return(<div>

            <div className={'row'}>
                <div className={'col col-sm-12'} style={{height:'88vh', padding:0}}>
                    <div className={'col col-sm-12'} style={{height:'100%', borderBottom:'1px solid #ccc',padding:0}}>

                        <div style={{width:'100%',float:'left',background:'linear-gradient(#fff,#ccc)',
                            padding:'4px 24px'}}>
                            <div style={{fontSize:'16px',marginTop:'6px',float:'left'}}>
                                <span className={'fa fa-question-circle'}/>Questionnaires
                            </div>




                            <select style={{ marginLeft:'160px', width:'70%'}}  name={'hamlet'} onChange={this.handleChanges}>
                                    <option>- Select Hamlet -</option>
                                    {this.state.hamlets.map((d,i)=>{
                                        return(<option key={i} value={d.id}>{d.name}</option>)
                                    })}
                                </select>

                        </div>
                        <div className={'row'}>
                            <div className={'col col-sm-3'} style={{height:'83vh',padding:0,borderRight:'1px solid #ccc',overflow:'auto'}}>
                                <div style={{padding:'8px 24px 8px 48px',background:'#efefef', marginBottom:'8px'}}>
                                    Available Questionnaires
                                </div>
                                <ul style={{listStyleType:'none'}}>

                                    {this.state.lus_elements.map((d,i)=>{
                                        return(<li key={i} onClick={()=>this.showQuestionnaireAt(d,i)} className={'left-menu-third'} style={{padding:'2px 4px'}}>
                                            <b>
                                                <span className={d.status===0?'fa fa-times':d.status===1?'fa fa-refresh':'fa fa-check'}/>{d.name}
                                            </b>
                                    </li>)
                                    })}
                                </ul>
                            </div>
                            <div className={'col col-sm-8'} style={{paddingLeft:0,height:'83vh',overflow:'auto'}}>
                                <div style={{padding:'8px',color:'#008',width:'100%',float:'left',borderBottom:'1px solid #ccc'}}>
                                    <b>{this.state.quest_name}</b>
                                    {/*<div style={{float:'right',fontSize:'12px'}}>
                                        <button className={'ubtn-success'} style={{marginRight:'8px'}}  title={'Download Draft Data'} onClick={()=>this.downloadDraft()}>
                                            <span className={'fa fa-check'} /> Approve
                                        </button>
                                         <button className={'ubtn-warning'}   title={'Upload Draft Data'} onClick={()=>PopUp.show('Upload Draft',<UploadShapeFile
                                             categ={'draft_data'} accept={'.zip,.ZIP'} afterSubmit={this.loadData()}/>)}>
                                            <span className={'fa fa-times'} /> Reject
                                        </button>
                                    </div>*/}

                                </div>

                                <div style={{width:'100%',float:'left'}}>
                                    {this.state.tabs.map((d,i)=>{
                                        return(<div onClick={()=>this.showTabAt(i,d)} key={i} style={{width:'120px'}}
                                                    className={i===this.state.current_tab?'tab tab-active':'tab'}>
                                            <span className={'fa fa-question-circle'}/>{d}
                                        </div>)
                                    })}
                                </div>
                                {this.state.current_tab_pane}
                            </div>
                        </div>
                    </div>

                </div>


            </div>

        </div>)
    }

    loadData(){

       ReadService.fetchItems(this.props.project.id).then(r=>{
            try {
                this.setState({
                    lus_elements:r.data.results
                })
            }catch (e){
                console.log(e)
            }
        })

        ReadService.fetchHamlets(this.props.village.id).then(r => {
            this.setState({
                hamlets:r.data.results
            })
        })
    }

    showQuestionnaireAt(d,i){
        let vid = this.state.village

        console.log(d)
        //console.log(d.params.dodoso)
        try {
            this.setState({
                dodoso:d.params.dodoso,
                quest_name:d.name,
                current_tab:0,
                current_tab_pane: <QNShortAnswers dodoso={d.params.dodoso} key={new Date().getMilliseconds()}/>
            })
        }catch (e) {
            console.log(e)
        }
        if (vid===0){
            //alert('Please Select Village...')
            return
        }
        ReadService.fetchQuestionnaires({
            vid:vid,
            qid:d.id
        }).then(r => {
            try {
                console.log(r.data)
            }catch (e) {
                console.log(e)
            }
        })
    }


    showTabAt(i, d) {
        console.log(d)
        let tab_pane = [
            <QNShortAnswers dodoso={this.state.dodoso} key={new Date().getMilliseconds()}/>,
            <div>Loading..</div>,
            <div>Loading..</div>,
            <div>Loading..</div>
        ]
        /*<TableAnswers dodoso={this.state.dodoso} key={new Date().getMilliseconds()}/>,
            <GraphsAnswers dodoso={this.state.dodoso} key={new Date().getMilliseconds()}/>,
            <AnalysisAnswers dodoso={this.state.dodoso} key={new Date().getMilliseconds()}/>*/
        this.setState({
            current_tab:i,
            current_tab_pane:tab_pane[i]
        })
    }
}